import React from 'react';
import { Archive, Trash2 } from 'lucide-react';
import API from '../api';
import { useConfirm } from './ConfirmDialog';

/**
 * Bottoni Archivia / Cancella riutilizzabili per le entita principali.
 * entity: 'pratiche' | 'preventivi' | 'computi' | 'cantieri' | 'clienti' | 'fornitori'
 */
export default function RowActions({ entity, id, label = 'elemento', onChange, compact = false, stopPropagation = true }) {
  const confirm = useConfirm();

  const wrap = (fn) => (e) => {
    if (stopPropagation) {
      e.stopPropagation();
      e.preventDefault();
    }
    fn();
  };

  const archivia = async () => {
    const ok = await confirm({
      title: 'Archivia elemento',
      message: `Vuoi archiviare ${label}?\nResterà disponibile in Archivio e potrai ripristinarlo in qualsiasi momento.`,
      confirmLabel: 'Archivia',
      cancelLabel: 'Annulla',
      variant: 'warning',
    });
    if (!ok) return;
    try {
      await API.post(`/api/archivio/${entity}/${id}/archive`);
      if (onChange) onChange();
    } catch (e) {
      alert('Errore archiviazione: ' + (e.response?.data?.detail || e.message));
    }
  };

  const cancella = async () => {
    const ok = await confirm({
      title: 'Eliminazione definitiva',
      message: `Stai per ELIMINARE DEFINITIVAMENTE ${label}.\n\nL'operazione è irreversibile e cancella anche i dati collegati.`,
      confirmLabel: 'Elimina',
      cancelLabel: 'Annulla',
      variant: 'danger',
    });
    if (!ok) return;
    try {
      await API.delete(`/api/archivio/${entity}/${id}`);
      if (onChange) onChange();
    } catch (e) {
      alert('Errore eliminazione: ' + (e.response?.data?.detail || e.message));
    }
  };

  if (compact) {
    return (
      <span className="inline-flex items-center gap-1">
        <button
          onClick={wrap(archivia)}
          data-testid={`archive-${entity}-${id}`}
          className="p-1.5 text-slate-500 hover:bg-amber-50 hover:text-amber-600 rounded transition-colors"
          title="Archivia"
        >
          <Archive size={14} />
        </button>
        <button
          onClick={wrap(cancella)}
          data-testid={`delete-${entity}-${id}`}
          className="p-1.5 text-slate-500 hover:bg-red-50 hover:text-red-600 rounded transition-colors"
          title="Elimina definitivamente"
        >
          <Trash2 size={14} />
        </button>
      </span>
    );
  }

  return (
    <span className="inline-flex items-center gap-2">
      <button
        onClick={wrap(archivia)}
        data-testid={`archive-${entity}-${id}`}
        className="inline-flex items-center gap-1.5 px-2.5 py-1.5 text-xs font-bold text-amber-700 border border-amber-200 hover:bg-amber-50 rounded-md transition-colors"
      >
        <Archive size={14} />
        Archivia
      </button>
      <button
        onClick={wrap(cancella)}
        data-testid={`delete-${entity}-${id}`}
        className="inline-flex items-center gap-1.5 px-2.5 py-1.5 text-xs font-bold text-red-700 border border-red-200 hover:bg-red-50 rounded-md transition-colors"
      >
        <Trash2 size={14} />
        Elimina
      </button>
    </span>
  );
}
